exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bedSelector {\n  width: 280px;\n}\n.detailsRow {\n  margin-bottom: 10px;\n}\n", ""]);

// exports
